<section class="px-4 md:px-8 lg:px-15  w-full bg-white dark:bg-slate-800 pb-10">
    <div class="flex flex-col items-center justify-center pt-15">
        <div class="w-full flex justify-center items-center mb-15">
            <div class="w-full flex-col flex md:flex-row lg:flex-row justify-between items-center">
                <div class="flex flex-col">
                    <div class="flex items-baseline">
                        @if (view.site && view.site.profile && view.site.profile.heading) {
                                @switch (view.site.profile.heading.position) {
                                    @case (1) {
                                        <app-heading_section-type01 [options]="{heading:'Airlines Flight',title:'Featured Flight Deals ',image:'', description:'',swooshAlign: {'margin':''} }" ></app-heading_section-type01>
                                        }
                                    @case (2) {
                                        <app-heading_section-type01 [options]="{heading:'Airlines Flight',title:'Featured Flight Deals ',image:'assets/xltravel/swoosh-01.svg', description:''}" ></app-heading_section-type01>
                                    }
                                }
                            }
                    </div>
                </div>
                <div class="flex  items-center flex-row gap-2 mt-4 justify-between">
                    <div
                        class="flex items-center justify-center sm:mb-3 md:mb-0 md:mr-2 w-20 h-8 rounded-lg bg-primary-100 hover:bg-primary-500 cursor-pointer transition transition-duration: 500ms  hover:text-accent-100 border-none">
                        <p class="px-6 text-sm text-primary-500 hover:text-primary-100 md:text-lg font-bold">
                            All
                        </p>
                    </div>
                    <div
                        class="flex items-center justify-center sm:mb-3 md:mb-0 md:mr-2 w-25 h-8 rounded-lg bg-primary-100 hover:bg-primary-500 cursor-pointer transition transition-duration: 500ms hover:bg-accent-700 border-none">
                        <p class="px-6 text-sm text-primary-500 hover:text-primary-100 md:text-lg font-bold">
                            One Way
                        </p>
                    </div>
                    <div
                        class="flex items-center justify-center  sm:mb-3 md:mb-0 md:mr-2 w-35 h-8 rounded-lg bg-primary-100 hover:bg-primary-500 cursor-pointer transition transition-duration: 500ms hover:text-accent-700 border-none">
                        <p class="px-6 text-sm text-primary-500 hover:text-primary-100 md:text-lg font-bold">
                            Round Trip
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class=" w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-8 lg:gap-8">
            <fuse-card class="w-full mx-auto">
                <div class="w-full overflow-hidden shadow-md hover:shadow-lg">
                    <div class="relative">
                        <img class="w-full h-60"
                            src="https://images.pexels.com/photos/2064827/pexels-photo-2064827.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                            alt="Destination Image" />
                        <div
                            class="absolute top-0 right-0 text-white px-8 py-10 text-3xl tracking-wider font-primary text-shadow">
                            Paris
                        </div>
                    </div>
                    <div class="p-5 bg-slate-100 dark:bg-slate-900">
                        <div class="flex">
                            <mat-icon class="text-primary-500 mr-2" [svgIcon]="'mat_solid:airplanemode_active'"></mat-icon>
                            <h3 class="text-lg text-gray-400">American Airlines</h3>
                        </div>
                        <p class="text-3xl font-primary font-semibold mb-2">
                            London to Paris
                        </p>
                        <div class="flex items-center justify-between">
                            <div class="flex flex-col space-y-2">
                                <p class="text-gray-400">One Way Flight</p>
                                <p class="text-gray-400">
                                    From
                                    <span class="text-primary-500 font-semibold">$450.00</span>
                                </p>
                            </div>
                            <button
                                class="ring-accent-500 font-bold py-2 px-6 transition transition-duration: 500ms hover:bg-accent-500 hover:text-accent-100">
                                Book Now
                            </button>
                        </div>
                    </div>
                </div>
            </fuse-card>
            <fuse-card class="w-full mx-auto">
                <div class="w-full overflow-hidden shadow-md hover:shadow-lg">
                    <div class="relative">
                        <img class="w-full h-60"
                            src="https://wise.com/imaginary-v2/a1aff2ea163604c7be42140235af0772.jpg?width=1200"
                            alt="Destination Image" />
                        <div
                            class="absolute top-0 right-0 text-white px-8 py-10 text-3xl tracking-wider font-primary text-shadow">
                            Dubai
                        </div>
                    </div>
                    <div class="p-5 bg-slate-100 dark:bg-slate-900">
                        <div class="flex">
                            <mat-icon class="text-primary-500 mr-2" [svgIcon]="'mat_solid:airplanemode_active'"></mat-icon>
                            <h3 class="text-lg text-gray-400">American Airlines</h3>
                        </div>
                        <p class="text-3xl font-primary font-semibold mb-2">
                            Paris to Dubai
                        </p>
                        <div class="flex items-center justify-between">
                            <div class="flex flex-col space-y-2">
                                <p class="text-gray-400">One Way Flight</p>
                                <p class="text-gray-400">
                                    From
                                    <span class="text-primary-500 font-semibold">$450.00</span>
                                </p>
                            </div>
                            <button
                                class="ring-accent-500  font-bold py-2 px-6 transition transition-duration: 500ms hover:bg-accent-500 hover:text-accent-100">
                                Book Now
                            </button>
                        </div>
                    </div>
                </div>
            </fuse-card>
            <fuse-card class="w-full mx-auto">
                <div class="w-full overflow-hidden shadow-md hover:shadow-lg">
                    <div class="relative">
                        <img class="w-full h-60"
                            src="https://images.pexels.com/photos/1024993/pexels-photo-1024993.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1"
                            alt="Destination Image" />
                        <div
                            class="absolute top-0 right-0 text-white px-8 py-10 text-3xl tracking-wider font-primary text-shadow">
                            Maldives
                        </div>
                    </div>
                    <div class="p-5 bg-slate-100 dark:bg-slate-900">
                        <div class="flex">
                            <mat-icon class="text-primary-500 mr-2" [svgIcon]="'mat_solid:airplanemode_active'"></mat-icon>
                            <h3 class="text-lg text-gray-400">American Airlines</h3>
                        </div>
                        <p class="text-3xl font-primary font-semibold mb-2">
                            India to Maldives
                        </p>
                        <div class="flex items-center justify-between">
                            <div class="flex flex-col space-y-2">
                                <p class="text-gray-400">One Way Flight</p>
                                <p class="text-gray-400">
                                    From
                                    <span class="text-primary-500 font-semibold">$450.00</span>
                                </p>
                            </div>
                            <button
                                class="ring-accent-500 font-bold py-2 px-6 transition transition-duration: 500ms hover:bg-accent-500 hover:text-accent-100">
                                Book Now
                            </button>
                        </div>
                    </div>
                </div>
            </fuse-card>
        </div>
    </div>
</section>